export default __webpack_public_path__ + "static/media/eyes.2e84d050.jpeg";